export default function About() {
  return (
    <section className="section aboutSection">
      <div className="aboutCard">
        <h2>About Soulful Customs</h2>

        <p>
          Soulful Customs offers a wide variety of customized keepsakes and
          display pieces designed to preserve your most meaningful moments. Our
          collection includes custom glass frames, stone slate frames, and other
          personalized display items available in multiple styles and sizes.
          Each piece is thoughtfully crafted and includes a display stand.
        </p>

        <br />

        <p>
          These one-of-a-kind personalized creations make meaningful gifts for
          Mother’s Day, Father’s Day, graduations, Valentine’s Day, birthdays,
          anniversaries, and many other special occasions.
        </p>

        <br />

        <p>
          Customers may also add short custom phrases to their photos for an
          additional charge per frame.
        </p>

        <ul className="aboutList">
          <li>Names</li>

          <li>“I Love You”</li>

          <li>“Happy Mother’s Day”</li>

          <li>“Congrats Grad 2026”</li>
        </ul>

        <p>
          Due to the personalized nature of our products, full payment is
          required at the time of order and is <strong>non-refundable</strong>.
        </p>

        <br />

        <p>
          Orders are typically completed and ready for pickup within{" "}
          <strong>4–5 Business Days</strong> of purchase.
        </p>

        <br />

        <p>
          Thank you for allowing Soulful Customs to create memorable gifts and
          keepsakes for you and your loved ones.
        </p>
      </div>
    </section>
  );
}
